module.exports = __webpack_public_path__ + "img/ErsteKarateprüfung.dba4b6fe.svg";